import Vue from 'vue'
import _get from 'lodash/get'
import _set from 'lodash/set'
import _has from 'lodash/has'
import _toPath from 'lodash/toPath'

export default function reactiveSet (obj = {}, property, value) {
  const path = _toPath(property)

  if (path.length > 1) {
    deepReactiveSet(obj, path, value)
  } else {
    shallowReactiveSet(obj, property, value)
  }
}

function shallowReactiveSet (obj, property, value) {
  const hasProperty = _has(obj, property)

  const propertyAsNumber = Number(property)
  const isUpdatingArray = !isNaN(propertyAsNumber)

  if (hasProperty && !isUpdatingArray) {
    _set(obj, property, value)
  } else {
    if (isUpdatingArray) {
      Vue.set(obj, propertyAsNumber, value)
    } else {
      Vue.set(obj, property, value)
    }
  }
}

function deepReactiveSet (obj, path, value) {
  const hasPath = _has(obj, path)
  const pathHasArrays = path.some(property => !isNaN(Number(property)))

  if (hasPath && !pathHasArrays) {
    const property = path.pop()
    shallowReactiveSet(_get(obj, path), property, value)
  } else {
    let objFrag = obj
    const lastProperty = path.pop()
    path
      .map((property, index) => {
        const isNextArray = !isNaN(Number(path[index + 1]))
        const isCurrentArray = !isNaN(Number(property))

        return {
          property: isCurrentArray ? Number(property) : property,
          initialValue: isNextArray ? [] : {},
        }
      })
      .forEach(({ property, initialValue }, index) => {
        const hasProperty = _has(objFrag, property)
        // If parent key is not defined we first have to crate it to be able to add nested value
        if (!hasProperty || objFrag[property] === null || objFrag[property] === undefined) {
          Vue.set(objFrag, property, initialValue)
        }
        objFrag = objFrag[property]
      })
    shallowReactiveSet(objFrag, lastProperty, value)
  }
}
